const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!BACKEND_URL) {
  throw new Error("REACT_APP_BACKEND_URL non configurato");
}

export const API_BASE = `${BACKEND_URL}/api`;

// Errori di validazione del server (lista di {loc, msg, type}) in una frase leggibile, con il nome del campo
const FIELD_LABELS = {
  business_name: "Ragione sociale", legal_address: "Sede legale", city: "Città", province: "Provincia", zip_code: "CAP",
  ateco_code: "Codice ATECO", vat_number: "Partita IVA", fiscal_code: "Codice fiscale", pec_email: "PEC",
  ordinary_email: "Email", email: "Email", password: "Password", name: "Nome", phone: "Telefono", total_workers: "Lavoratori totali",
};
function validationMessage(items) {
  const parts = items.map((it) => {
    const field = [...(it.loc || [])].reverse().find((x) => typeof x === "string" && x !== "body");
    const label = FIELD_LABELS[field] || field || "Dato";
    if (it.type === "string_too_short") return `${label}: obbligatorio (almeno ${it.ctx?.min_length ?? 1} caratteri)`;
    if (it.type === "string_too_long") return `${label}: troppo lungo (massimo ${it.ctx?.max_length} caratteri)`;
    if (it.type === "missing") return `${label}: obbligatorio`;
    if (String(it.type).startsWith("value_error")) return `${label}: ${String(it.msg || "").replace(/^Value error, /, "")}`;
    return `${label}: ${it.msg || "non valido"}`;
  });
  return Array.from(new Set(parts)).join(" · ");
}

export async function apiRequest(path, options = {}) {
  const token = localStorage.getItem("dvr_token");
  const isFormData = options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(options.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });
  const text = await response.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { detail: text };
    }
  }
  if (!response.ok) {
    const d = data?.detail;
    const err = new Error(typeof d === "string" ? d : Array.isArray(d) ? validationMessage(d) : d && d.message ? d.message : d ? JSON.stringify(d) : "Operazione non riuscita");
    if (d && typeof d === "object" && !Array.isArray(d)) { err.code = d.code; err.data = d; } // es. doppione: il chiamante decide
    err.status = response.status; // serve a distinguere "sessione scaduta" da "nessuna rete"
    throw err;
  }
  return data;
}

export async function downloadFile(path, fallbackName = "documento", options = {}) {
  const token = localStorage.getItem("dvr_token");
  const response = await fetch(`${API_BASE}${path}`, {
    method: options.method || "GET",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: options.body,
  });
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(text || "Download non riuscito");
  }
  const disposition = response.headers.get("content-disposition") || "";
  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)"?/i);
  const filename = match ? decodeURIComponent(match[1]) : fallbackName;
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}